import { useEffect } from 'react';
import Local from './common/classes/local';
import getUrlParameters from './common/functions/getUrlParameters';
import { loadGlobalHeader } from './common/functions/loadGlobalHeader';
import './GlobalHeader.css';

interface GlobalHeaderProps {
    enableLiveChat: boolean,
    enableTimeout: boolean,
}

export const GlobalHeader = (props: GlobalHeaderProps) => {
    const { enableLiveChat, enableTimeout } = props;
    useEffect(() => {
        loadGlobalHeader();
    }, []);
    const language = Local.getItem('language') === 'Spanish' ? 'es' : 'en';

    const params = getUrlParameters();
    params.delete('lang');
    params.set('Lang', language === 'es' ? 'en-us' : 'es-mx');
    const langLink = '?' + params.toString();

    return (
        <div
            id="root"
            login-url="/account/login"
            lang={language}
            lang-toggle-link={langLink}
            enable-live-chat={String(enableLiveChat)}
            enable-timeout={String(enableTimeout)}
        >
            <div id="ch-root-temp">
                <header>
                    <section
                        aria-label="Official government website"
                    ></section>
                    <div className="ch-c-header-temp">
                        <a href="/">
                            <img
                                className="medicare-logo"
                                src={process.env.REACT_APP_HEADER_URL + "static/media/medicare-logo-green.9e8316a5.svg"}
                                alt="Medicare.gov"
                            />
                        </a>
                    </div>
                </header>
            </div>
        </div>
    );
};
